import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  Table,
  Button,
} from '../../components/index';
import {
  doGet,
  doPut,
  trataMensagensErro,
  trataMensagemSucesso,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import { msgsconfirmacaoFechamentoPagamento } from '../../utils/constants';
// import * as constantes from '../../utils/constants';
import ModalAlerta from '../requerimentos/ModalAlerta';
import { manterApenasFiltro } from '../../utils/helpers';

class ConsultaPagamentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      registroVindoDoRequest: null,
      showNoContent: false,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      showModalAlerta: false,
      fechamentoPagamento: {
        ano: null,
        mes: null,
      },
    };
  }

  componentDidMount() {
    manterApenasFiltro('');
    this.realizaConsulta();
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  lotacao = this.props.auth.userData.lotacoes[0];

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }

    // Copiar atributos além do filtro
    // const atributosConsulta = this.verificaAtributosParaConsulta();
    // if (atributosConsulta) {
    //   if (filtrosConsulta.estado === undefined) {
    //     filtrosConsulta.estado = atributosConsulta.estados;
    //   }
    //   filtrosConsulta.participacao = atributosConsulta.tipoParticipacao;
    //   filtrosConsulta['atributo-ordenacao'] = atributosConsulta.campoOrdenacao;
    //   if (atributosConsulta.filtroTipoExigencias) {
    //     filtrosConsulta['tipo-exigencia'] = atributosConsulta.filtroTipoExigencias;
    //   }
    // }
    this.setState({ ...this.state, filtrosConsulta }, this.executaConsulta);
  }

  executaConsulta = () => {
    // if (Object.entries(this.state.filtrosConsulta).length !== 0) {
    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    doGet(
      'fechamento-pagamentos',
      this.tratarSucesso,
      this.tratarErro,
      {
        // ...this.state.filtrosConsulta,
        'start-position': primeiroItem,
        'max-results': resultadosPorPagina,
      },
    );
    // } else {
    //   this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
    // }
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = {};

    // atributos = { ...atributos, filtro: filtroValido };

    // if (atributosPesquisa.competencia) {
    //   atributos = { ...atributos, competencia: atributosPesquisa.competencia };
    // }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: [],
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: response.data,
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */
  tratarFiltroNaLista = (listaRegistrosFiltrada) => {
    this.setState({ listaRegistrosFiltrada, listaRegistrosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Requerimento não encontrado para o protocolo informado.',
            noContentSecondaryMessage: 'Informe um protocolo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  addTipoRequerimentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoRequerimento, tipo).label
  )

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }

  formatarCompetencia = (competencia) => {
    let valor = '';
    if (competencia) {
      if (competencia.length === 6) {
        valor = `0${competencia}`;
      } else {
        valor = competencia;
      }
    }
    return valor;
  }

  showFechamentoAtualizacao = (row) => {
    this.setState({
      alertas: [msgsconfirmacaoFechamentoPagamento.confirmacaoFechamentoPagamento],
      showModalAlerta: !this.state.showModalAlerta,
      fechamentoPagamento: row,
    });
  }

  montaAcaoFechamento = (row, hint) => (
    <React.Fragment>
      {(this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])) ?
        <Button
          hint={hint}
          icon="ico-pencil"
          mini
          onClick={() => this.showFechamentoAtualizacao(row)}
        />
      : ''}
    </React.Fragment>
  );

  createActionColumn = (cell, row) => {
    if (row.dataEncerramentoFolha === undefined) {
      const hint = 'Fechar Pagamento';
      return this.montaAcaoFechamento(row, hint);
    }
    return '';
  };

  montaColunas = () => {
    const consultaPagamentoTableHeader = this.colunasDefault.slice();
    consultaPagamentoTableHeader.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
    return consultaPagamentoTableHeader;
  }

  colunasDefault = [
    {
      id: 'competencia',
      label: 'Competência',
      dataFormat: this.formatarCompetencia,
    }, {
      id: 'dataEncerramentoFolha',
      label: 'Data Encerramento Folha',
    }, {
      id: 'dataEncerramentoPrevia',
      label: 'Data Encerramento Prévia',
    }, {
      id: 'nomeUsuario',
      label: 'Nome do Servidor',
    }, {
      id: 'situacao',
      label: 'Situação',
    }];

  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }

  alterarPagina = (pagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  trataSucesso = () => {
    this.realizaConsulta();
    trataMensagemSucesso(['Prévia de pagamento inserida.']);
  }

  trataSucessoResponseEnvio = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    }, this.trataSucesso);
  }

  showInclusaoFechamentoPagamento = () => {
    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }
    const { fechamentoPagamento } = { ...this.state };
    doPut(
      'fechamento-pagamentos',
      fechamentoPagamento,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
      options,
    );
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
    }
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  render() {
    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.showInclusaoFechamentoPagamento}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    const options = {
      noDataText: 'Nenhum pagamento a ser exibido',
      hideSizePerPage: true,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const consultaPagamentoTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <Table
            legend="Fechamento de Pagamentos"
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={consultaPagamentoTableHeader}
            pagination
            remote
          />
          {modalAlerta}
        </DtpContentContainer>
      )
    );
  }
}

ConsultaPagamentos.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
};

ConsultaPagamentos.defaultProps = {
  match: null,
};

export default ConsultaPagamentos;



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaPagamentos.jsx